/* eslint-disable no-underscore-dangle */
import SearchClient from '../search';

export default class SuscriptorsClient extends SearchClient {
  constructor(options = {}) {
    super(options);
  }

  getListSuscriptorsUser = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'solicitudes/suscriptores' },
      );
      return response.data;
    } catch (error) {
      return error.response;
    }
  }

  getListSuscriptorsSolicitud = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: `solicitudes/${ data.id }/suscriptores` },
      );
      return response.data;
    } catch (error) {
      return error.response;
    }
  }

  postSuscriptors = async (data) => {
    try {
      data['idActivity'] = process.env.VUE_APP_ID_ACTIVITY_SUSCRIPTOR; // eslint-disable-line
      const response = await this.request('post')(
        { data },
        { path: `solicitudes/${ data.id }/suscriptores` },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  deleteSuscriptors = async (data) => {
    try {
      data['idActivity'] = process.env.VUE_APP_ID_ACTIVITY_SUSCRIPTOR; // eslint-disable-line
      const response = await this.request('delete')(
        { data },
        { path: `solicitudes/${ data.id }/suscriptores/${ data.uuid }` },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
}
